import ossaCreator from './creator';

export default ossaCreator;
